import React from 'react';
import { Typography } from '@mui/material';

interface AuthHeaderProps {
  mode: 'login' | 'signup';
  color?: string;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ mode, color }) => {
  const title = mode === 'signup' ? 'Sign Up' : 'Log In';

  return (
    <Typography
      variant="h2"
      sx={{
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 'bold',
        fontSize: mode === 'signup' ? '40px' : '32px',
        lineHeight: 'normal',
        color: color || 'white',
        textAlign: 'left',
        whiteSpace: 'nowrap',
      }}
    >
      {title}
    </Typography>
  );
};

export default AuthHeader;
